export const siteConfig = {
    name: 'PayPal Gebührenrechner',
    domain: 'paycal.org',
    url: 'https://paycal.org',
    description: 'PayPal Gebührenrechner mit aktuellen Gebühren von Januar 2025. Berechnen Sie genau Ihre PayPal-Gebühren oder Endsumme für alle Zahlungsarten ✓ Kostenlos ✓ Ohne Anmeldung',
    keywords: [
      'PayPal Gebührenrechner',
      'PayPal Gebühren 2025',
      'PayPal Kosten',
      'PayPal Händlerkonditionen',
      'Gebühren berechnen PayPal',
      'PayPal Gebühren Deutschland'
    ]
  };
  
  export const schemaData = {
    calculator: {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": "PayPal Gebührenrechner",
      "applicationCategory": "FinanceApplication",
      "operatingSystem": "Any",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "EUR"
      }
    },
    faqs: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Wie hoch sind die PayPal Gebühren für Verkäufer?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Für Waren und Dienstleistungen beträgt die Standardgebühr 2,49% plus 0,35€ pro Transaktion. Für Händler mit höherem Umsatz gibt es vergünstigte Konditionen."
          }
        },
        {
          "@type": "Question",
          "name": "Fallen PayPal Gebühren bei Freunde & Familie an?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Nein, bei Zahlungen an Freunde und Familie innerhalb Deutschlands fallen keine Gebühren an, sofern keine Währungsumrechnung erforderlich ist."
          }
        },
        {
          "@type": "Question",
          "name": "Wie berechnen sich die PayPal Händlerkonditionen?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Die Händlerkonditionen staffeln sich nach Umsatz: Bis 2.000€ (2,49% + 0,35€), 2.000-5.000€ (2,19% + 0,35€), 5.000-25.000€ (1,99% + 0,35€), über 25.000€ (1,79% + 0,35€)."
          }
        },
        {
          "@type": "Question",
          "name": "Wie funktioniert die PayPal QR-Code Zahlung?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Bei QR-Code Zahlungen fallen 0,5% + 0,10€ für Beträge über 10,01€ an. Für Beträge bis 10€ beträgt die Gebühr 1% + 0,05€."
          }
        },
        {
          "@type": "Question",
          "name": "Was sind die aktuellen PayPal Gebühren 2025?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Die aktuellen PayPal Gebühren 2025 betragen für Standard-Transaktionen 2,49% plus 0,35€. Diese gelten seit Januar 2025 für Waren und Dienstleistungen. Für andere Zahlungsarten wie Spenden oder QR-Code-Zahlungen gelten spezielle Konditionen."
          }
        }
      ]
    }
  };